import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconProject = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M4.667 10.422h14.666M4.667 16.437h14.666M3.444 5.61V4.406M20.556 5.61V4.406M2.466 5.61h19.067c.81 0 1.467.637 1.467 1.422v12.797c0 .785-.657 1.422-1.467 1.422H2.467c-.81 0-1.467-.637-1.467-1.422V7.031c0-.785.657-1.422 1.467-1.422zm13.165-2.787c-.108-.24-.316-.448-.594-.595A2.045 2.045 0 0014.085 2h-4.17c-.342 0-.675.08-.953.227-.277.147-.485.356-.593.595L7.111 5.61h9.778L15.63 2.822z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconProject.displayName = "IconProject";

export { IconProject };
